// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartlineContainerStyles } from "@tps/App/Components/Cart/CartLineContainer";
import { color, getSystemColor, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cartlineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 80px 1fr 1.4fr 1.1fr 1.1fr 1.1fr;
        grid-column-gap: 0;
        background: ${color("common.background")};
        border: 1px solid ${color("common.ui4")};
        padding: 12px;
        width: 100%;
        @media print {
            width: 100%;
            content: "";
            display: table;
            clear: both;
            -webkit-column-break-inside: avoid;
            page-break-inside: avoid;
            break-inside: avoid;
            border: 1px solid ${getSystemColor("common.border")};
            &&&:not(:last-child) {
                border-bottom: 1px solid ${getSystemColor("common.border")};
                margin-bottom: -1px;
            }
        }
        &:not(:last-child) {
            border-bottom: 0;
        }
    `,
};
cartlineContainerStyles.image = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 3;
            margin-bottom: 12px;
        }
        @media print {
            min-width: 120px;
            min-height: 120px;
            margin-bottom: 0;
            float: left;
        }
    `,
};
cartlineContainerStyles.description = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 1 / 2;
        position: relative;
        padding: 0 12px;
        ${xScreen("lte", "md")} {
            grid-column: 2 / 7;
            grid-row: 1 / 3;
        }
        @media print {
            min-width: 75%;
            max-width: 75%;
            min-height: 120px;
            float: right;
        }
    `,
};
cartlineContainerStyles.price = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 2;
        position: relative;
        padding: 0 12px;
        padding-left: 10px;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 3 / 4;
            padding-left: 0;
        }

        @media print {
            min-width: 25%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.qty = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 2;
        padding: 0 12px;
        padding-left: 14px;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 4 / 5;
            padding-left: 0;
            padding-right: 17px;
        }

        @media print {
            margin-right: 0;
            min-width: 40%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.total = {
    css: css`
        grid-column: 6 / 7;
        grid-row: 1 / 2;
        position: relative;
        text-align: right;

        ${xScreen("lte", "md")} {
            grid-column: 4 / 7;
            grid-row: 4 / 5;
            padding-left: 0;
            text-align: left;
        }
        @media print {
            min-width: 35%;
            min-height: 50px;
            float: right;
        }
    `,
};

cartlineContainerStyles.actions = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 2 / 3;
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 0 12px;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 5 / 6;
            padding-top: 10px;
            padding-left: 0;
            padding-right: 0;
        }

        @media print {
            display: none;
        }
    `,
};
cartlineContainerStyles.notes = {
    css: css`
        grid-column: 2 / 7;
        grid-row: 4 / 5;
        position: relative;
        padding: 0 0 0 12px;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            grid-row: 6 / 7;
            padding-left: 0;
        }

        @media print {
            min-width: 100%;
            float: left;
        }
    `,
};
